import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../services/api.service';
import {PageComponent} from '../../page.component';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {HttpErrorResponse} from '@angular/common/http';
import {ResetPasswordSuccessDialogComponent} from '../../dialogs/reset-password-success/reset-password-success.dialog.component';

@Component({
  selector: 'mp-reset-password-confirm',
  templateUrl: 'reset-password-confirm.component.html',
  styleUrls: ['reset-password-confirm.component.css']
})
export class ResetPasswordConfirmComponent extends PageComponent implements OnInit {

  loading = false;

  key: string;
  email: string;

  errFailure: boolean;
  errInvalidCode: boolean;

  constructor(private readonly apiService: ApiService,
              private dialog: MatDialog,
              private activatedRoute: ActivatedRoute) {
    super();
  }

  isLightPage(): boolean {
    return true;
  }

  canGoBack(): boolean {
    return false;
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params.key !== undefined) {
        this.key = params.key;
      }

      if (params.key !== undefined) {
        this.email = params.email;
      }
    });
  }


  submit(): void {
    this.resetErrors();
    this.loading = true;

    this.apiService.resetPasswordConfirm(this.key)
      .subscribe(() => {
        this.loading = false;

        this.dialog.open(ResetPasswordSuccessDialogComponent, {
          disableClose: true,
          data: {
            email: this.email,
            isConfirm: true
          }
        });
      }, (err: HttpErrorResponse) => {
        this.loading = false;

        if (err.status === 401) {
          this.errInvalidCode = true;
        } else {
          this.errFailure = true;
        }
      });
  }

  private resetErrors(): void {
    this.errFailure = false;
  }
}
